import { computed } from "vue";
import { getChannelId, getTenantId, getToken } from "../utils/channelStorage";

const BASE = import.meta.env.VITE_API_BASE_URL;
const LOCAL = import.meta.env.VITE_API_LOCAL_URL;

function getLocalFromURL() {
  // 使用当前页面URL的查询参数
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("local") || "false";
}

export function useUpload(uploadUrl: string) {
  const token = getToken();
  const channelId = getChannelId();

  const localParam = getLocalFromURL();
  console.log("upload", localParam);
  const URL = localParam === "true" ? LOCAL : BASE;
  /**
   * 文件上传请求头。
   * Tenant-Id 走 getTenantId()：访客用 channelId，客服用 memberId，与 simple-api makeRequest 对齐。
   */
  const uploadHeader = computed(() => {
    return {
      Authorization: "Bearer " + (token ?? ""),
      "Tenant-Id": getTenantId() ?? "",
    };
  });

  /**
   * 上传地址
   */
  const uploadAction = computed(() => {
    return URL + uploadUrl;
  });

  return {
    uploadHeader,
    uploadAction,
  };
}
